"use client";

import React from "react";
import {
  TextField,
  SxProps,
  Theme,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material"; // Ícones para mostrar/ocultar senha

/**
 * Tipagem das propriedades do InputField, com suporte para mostrar/ocultar senha.
 */
interface InputFieldProps {
  label: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  error?: boolean;
  helperText?: string;
  sx?: SxProps<Theme>; // Permite estilizar por fora do componente
  showPasswordToggle?: boolean; // Indica se o campo pode alternar a visibilidade da senha
  onTogglePasswordVisibility?: () => void; // Função para alternar a visibilidade da senha
}

/**
 * Componente de campo de entrada de texto, incluindo a possibilidade de mostrar/ocultar a senha.
 */
const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  value,
  onChange,
  placeholder,
  error,
  helperText,
  sx,
  showPasswordToggle = false,
  onTogglePasswordVisibility,
}) => {
  return (
    <TextField
      label={label}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      fullWidth
      margin="normal"
      variant="outlined"
      size="medium"
      error={error}
      helperText={helperText}
      sx={{ mb: 3, ...sx }} // Espaçamento padrão + personalização
      InputProps={
        showPasswordToggle
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={onTogglePasswordVisibility} // Alterna a visibilidade
                    edge="end"
                  >
                    {type === "password" ? <VisibilityOff /> : <Visibility />}{" "}
                    {/* Icone de olho */}
                  </IconButton>
                </InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};

export default InputField;
